<nav
    #breadcrumbContainer
    class="flex min-w-0 flex-1 items-center gap-2 overflow-hidden whitespace-nowrap"
    data-testid="breadcrumb-collapse-nav">
    <!-- Hidden full breadcrumb for measurement - OFF-SCREEN -->
    <div #fullBreadcrumb class="fixed -left-2499.75 flex gap-2 whitespace-nowrap" aria-hidden="true">
        @if (home()) {
            <span class="inline-flex items-center">
                @if (home()?.lucideIcon) {
                    <svg [lucideIcon]="home()!.lucideIcon ?? null"></svg>
                } @else {
                    <span class="font-sans">{{ home()?.label }}</span>
                }
            </span>
        }
        @if (home() && segments().length > 0) {
            <svg [lucideIcon]="ChevronRight" class="h-4 w-4 shrink-0"></svg>
        }
        @for (segment of segments(); track segment.url; let isLast = $last) {
            <span class="inline-flex items-center">
                <span class="font-sans">{{ segment.label }}</span>
            </span>
            @if (!isLast) {
                <svg [lucideIcon]="ChevronRight" class="h-4 w-4 shrink-0"></svg>
            }
        }
    </div>

    @if (home()) {
        <a
            [routerLink]="home()?.url"
            class="group inline-flex items-center gap-2 transition-colors"
            [pTooltip]="home()?.tooltip"
            [tooltipPosition]="'bottom'">
            @if (home()?.lucideIcon) {
                <svg
                    [lucideIcon]="home()!.lucideIcon ?? null"
                    class="h-6 w-6 text-[var(--p-button-secondary-color)] group-hover:text-[var(--p-button-secondary-hover-color)]"></svg>
            } @else {
                <span
                    class="font-sans text-[var(--p-button-secondary-color)] group-hover:text-[var(--p-button-secondary-hover-color)]">
                    {{ home()?.label }}
                </span>
            }
        </a>
    }

    @if (home() && segments().length > 0) {
        <svg [lucideIcon]="ChevronRight" class="h-4 w-4 shrink-0 text-[var(--p-button-secondary-color)]"></svg>
    }

    <!-- Collapse button BEFORE segments in narrow mode -->
    @if (showCollapseButton() && isNarrowContainer()) {
        <ng-container *ngTemplateOutlet="collapseButton" />
        <svg [lucideIcon]="ChevronRight" class="h-4 w-4 shrink-0 text-[var(--p-button-secondary-color)]"></svg>
    }

    @for (segment of visibleSegments(); track segment.url; let i = $index; let isLast = $last) {
        <a
            [routerLink]="segment.routerLink"
            class="group inline-flex items-center transition-colors"
            [class.overflow-hidden]="isLast"
            [pTooltip]="isLast ? segment.label : undefined"
            [tooltipPosition]="'bottom'"
            role="link"
            aria-label="{{ segment.label }}">
            <span
                class="pt-1 font-sans font-semibold text-[var(--p-button-secondary-color)] group-hover:text-[var(--p-button-secondary-hover-color)]"
                [class.truncate]="isLast">
                {{ segment.label }}
            </span>
        </a>

        <!-- Collapse button (shown between first and last segment in wide mode) -->
        @if (showCollapseButton() && !isNarrowContainer() && i === 0) {
            <svg [lucideIcon]="ChevronRight" class="h-4 w-4 shrink-0 text-[var(--p-button-secondary-color)]"></svg>
            <ng-container *ngTemplateOutlet="collapseButton" />
        }

        @if (!isLast) {
            <svg [lucideIcon]="ChevronRight" class="h-4 w-4 shrink-0 text-[var(--p-button-secondary-color)]"></svg>
        }
    }

    <p-popover #popover>
        <div class="flex min-w-52 flex-col gap-2 p-2">
            @for (segment of hiddenSegments(); track segment.url) {
                <a
                    [routerLink]="segment.routerLink"
                    class="hover:bg-surface-100 dark:hover:bg-surface-700 group block rounded px-3 py-2 transition-colors"
                    (click)="popover.hide()">
                    <span
                        class="font-sans font-semibold text-[var(--p-button-secondary-color)] group-hover:text-[var(--p-button-secondary-hover-color)]">
                        {{ segment.label }}
                    </span>
                </a>
            }
        </div>
    </p-popover>
</nav>

<ng-template #collapseButton>
    <button
        pButton
        type="button"
        variant="text"
        severity="secondary"
        class="inline-flex min-w-10 items-center justify-center rounded px-2 py-1 transition-colors"
        (click)="popover.toggle($event)"
        [pTooltip]="'More segments'"
        aria-label="Show hidden breadcrumb segments">
        <svg [lucideIcon]="MoreHorizontal" class="h-4 w-4"></svg>
    </button>
</ng-template>
